import SuperRepository from '../superRepository'

export default new (class PartnerSpendUpdateBlockRepository extends SuperRepository {
  baseUri() {
    return 'partner_spend_update_block'
  }
})()